import CollegePillsContainer from './collegePills';
export { CollegePillsContainer as CollegePills };
